import React, { ReactNode, useRef } from 'react'
import { Box } from '@mui/material'
import { useLocation } from 'react-router-dom'
import HeaderMenu from './HeaderMenu'
import { banhangKiotLike } from '@/components/layout/banhangKiotTokens'
import routerConstants from '@/constants/routerConstants'
import UiTestLiveRunner from '@/modules/ui-test/UiTestLiveRunner'
import VisualTesterHost from '@/modules/test-module-chitiet/tester/VisualTesterHost'

interface BasicLayoutProps {
  children: ReactNode
}

const isChatPath = (pathname: string): boolean =>
  pathname === routerConstants.chat || pathname.startsWith(`${routerConstants.chat}/`)

/** Shell: header full bleed (nền xanh phủ hết ngang); vùng nội dung dùng `kiotPageContentMarginXPx`, Toolbar dùng `kiotShellHeaderPaddingXPx` để khớp rail filter. */
const BasicLayout: React.FC<BasicLayoutProps> = ({ children }) => {
  const location = useLocation()
  const onChat = isChatPath(location.pathname)
  const gutter = `${banhangKiotLike.kiotPageContentMarginXPx}px`
  const contentRef = useRef<HTMLDivElement | null>(null)
  return (
    <Box
      component="main"
      sx={{
        width: '100%',
        maxWidth: '100vw',
        height: '100vh',
        minHeight: '-webkit-fill-available',
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        overflow: 'hidden',
        boxSizing: 'border-box',
        bgcolor: banhangKiotLike.pageCanvas,
      }}
    >
      <HeaderMenu />
      <Box
        ref={contentRef}
        component="div"
        sx={{
          flex: 1,
          minWidth: 0,
          minHeight: 0,
          px: onChat ? 0 : gutter,
          py: 0,
          display: 'flex',
          flexDirection: 'column',
          /** List one-screen tự cuộn trong rail/bảng — tránh chain scroll “nhún” cả trang. */
          overflow: 'hidden',
          backgroundColor: onChat ? '#fff' : banhangKiotLike.pageCanvas,
          boxSizing: 'border-box',
        }}
      >
        <UiTestLiveRunner screenRootRef={contentRef} />
        <VisualTesterHost screenRootRef={contentRef} />
        {children}
      </Box>
    </Box>
  )
}

export default BasicLayout
